import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParamGroup } from 'app/model/cliente/paramGroup.model';
import { EventEmitterService } from 'app/service/event-emitter-service';

import { ParamsService } from '../../../service/cliente/params/params.service';

@Component({
  selector: 'app-param-group-dialog',
  templateUrl: './param-group-dialog.component.html',
  styleUrls: ['./param-group-dialog.component.scss'],
})
export class ParamGroupDialogComponent implements OnInit {
  @ViewChild('group_name') inputName;
  @ViewChild('group_desc') inputDesc;

  public groupForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ParamGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paramService: ParamsService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.groupForm = this.fb.group({
      name: ['', Validators.required],
      desc: ['', Validators.required],
    });

    if (this.data.isEditGroup) {
      this.groupForm.setValue({
        name: this.data.groupToEdit.name,
        desc: this.data.groupToEdit.description,
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveParamGroup(name: string, description: string) {
    if (this.groupForm.valid) {
      this.isLoading = true;
      const paramGroup = new ParamGroup();

      paramGroup.name = name;
      paramGroup.description = description;
      // paramGroup.clientId = this.data.clientId;

      if (this.data.isEditGroup) {
        paramGroup.id = this.data.groupToEdit.id;
      }

      this.paramService.saveParamGroup(paramGroup).subscribe(
        (data) => {
          this.isLoading = false;
          this.openSnackBar('Grupo de parâmetros salvo com sucesso', false);

          EventEmitterService.get('isNewParamGroupSaved').emit(true);

          if (!this.data.isEditGroup) {
            this.groupForm.reset();
          }
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao salvar grupo de parâmetros', true);
        }
      );
    } else {
      this.openSnackBar('Preencha os campos Obrigatórios', true);
    }
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/param-group-dialog/param-group-dialog.component.ts